import ScreenPaidAdDetails from 'screens/PaidAd/Details';
import ScreenPaidAdUpdate from 'screens/PaidAd/Update';
import ScreenPaidAdCreate from 'screens/PaidAd/Create';
import ScreenPaidAdReportList from 'screens/PaidAd/Report/List';
import ScreenPaidAdReviewList from 'screens/PaidAd/Review';
import ScreenPaidAdReportDetails from 'screens/PaidAd/Report/Details';
import ScreenPaidAdList from 'screens/PaidAd/List';
import { PAID_AD } from 'routes/paths';

const paidadsRoutes = [
  {
    path: PAID_AD.CREATE,
    name: 'PaidAdCreate',
    component: ScreenPaidAdCreate,
    allowPermissions: ['add_ownership_autopaidad', 'add_autopaidad'],
  },
  {
    path: PAID_AD.UPDATE,
    name: 'PaidAdUpdate',
    component: ScreenPaidAdUpdate,
    allowPermissions: ['change_ownership_autopaidad', 'change_autopaidad'],
  },
  {
    path: PAID_AD.DETAILS,
    name: 'PaidAdDetails',
    component: ScreenPaidAdDetails,
    allowPermissions: ['view_ownership_autopaidad', 'view_autopaidad'],
  },
  {
    path: PAID_AD.REPORT.DETAILS,
    name: 'PaidAdReportList',
    component: ScreenPaidAdReportDetails,
    allowPermissions: ['report_autopaidad', 'report_ownership_autopaidad'],
  },
  {
    path: PAID_AD.REPORT.LIST,
    name: 'PaidAdReportList',
    component: ScreenPaidAdReportList,
    allowPermissions: ['report_autopaidad', 'report_ownership_autopaidad'],
  },
  {
    path: PAID_AD.REVIEW.LIST,
    name: 'PaidAdReviewList',
    component: ScreenPaidAdReviewList,
  },
  {
    path: PAID_AD.LIST,
    name: 'PaidAdList',
    component: ScreenPaidAdList,
    loginRequired: true,
    allowPermissions: ['list_ownership_autopaidad', 'list_autopaidad'],
  },
];

export default paidadsRoutes;
